import { Record, List, Set } from 'immutable';
import { PAYMENT_STATUSES } from './constants';
import type {
  PaymentInfoData,
  PaymentInvoiceData,
  RejectReasonData,
  BalanceData,
  PaymentApprovalsData,
  PaymentData,
  CachedPaymentData,
  PaymentInvoiceRecord,
  PaymentInvoicesList,
} from './types';

export const PaymentInfoFactory = Record<PaymentInfoData>({
  id: '',
  referenceNumber: '',
  status: PAYMENT_STATUSES.PREPARATION,
  vendorName: '',
  vendorId: '',
  payTo: '',
  payFrom: '',
  currencyCode: '',
  withholdingTax: null,
  withholdingTaxExpiryDate: '',
  paymentDate: '',
  totalAmount: '',
  transferReason: '',
});

export const PaymentInvoiceFactory = Record<PaymentInvoiceData>({
  id: '',
  referenceNumber: '',
  documentUrl: '',
  amount: '',
  amountToPayAfterTax: '',
  paidAmount: '',
  oldOutstandingAmount: '',
  amountToPay: '',
  newOutstandingAmount: '',
  invoiceDate: '',
  dueDate: '',
});

export const RejectReasonFactory = Record<RejectReasonData>({
  username: '',
  message: '',
});

export const BalanceFactory = Record<BalanceData>({
  amount: null,
  currency: '',
});

export const PaymentInvoicesListFactory = (rawInvoices: Array<Partial<PaymentInvoiceData>> = []): PaymentInvoicesList =>
  List(rawInvoices).map((item) => PaymentInvoiceFactory(item)) as List<PaymentInvoiceRecord>;

export const PaymentApprovalsFactory = Record<PaymentApprovalsData>({
  levels: List(),
  status: '',
  createdAt: '',
  updatedAt: '',
  templateId: '',
  nextLevelId: '',
  error: null,
  rejectReasons: List(),
});

export const PaymentTagsFactory = (tags: string[] = []): Set<string> => Set(tags);

export const PaymentFactory = Record<PaymentData>({
  info: PaymentInfoFactory(),
  invoices: List(),
  approvals: PaymentApprovalsFactory(),
  balance: BalanceFactory(),
  meta: {},
  tags: Set<string>(),
});

export const CachedPaymentFactory = Record<CachedPaymentData>({
  hash: null,
  downloadProgress: 0,
  url: null,
});
